import type { ReactNode } from "react";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

// --------------------------------- TYPES ---------------------------------
type FormInputEndAdornmentProps = {
	readonly texto: string;
	readonly maxLength?: number;
	readonly showMaxLengthCounter: boolean;
	readonly error: boolean;
	readonly rightIcon?: ReactNode;
	readonly onRightIconClick?: () => void;
	readonly rightIconAriaLabel: string;
};

// ------------------------------- COMPONENT -------------------------------
export default function FormInputEndAdornment({
	texto,
	maxLength,
	showMaxLengthCounter,
	error,
	rightIcon,
	onRightIconClick,
	rightIconAriaLabel,
}: Readonly<FormInputEndAdornmentProps>) {
	const mostrarContador = showMaxLengthCounter && typeof maxLength === "number";
	const contadorMaxLength = mostrarContador ? `${texto.length}/${maxLength}` : undefined;
	const contadorClassName = `min-w-10 text-right text-[0.6875rem] font-semibold leading-none ${
		error ? "text-danger" : "text-muted-foreground"
	}`;
	let rightIconContent: ReactNode = null;
	if (rightIcon) {
		rightIconContent = rightIcon;
		if (onRightIconClick)
			rightIconContent = (
				<IconButton
					edge="end"
					onClick={onRightIconClick}
					aria-label={rightIconAriaLabel}
					tabIndex={-1}
					size="small"
				>
					{rightIcon}
				</IconButton>
			);
	}
	return (
		<InputAdornment position="end">
			<div className="flex items-center gap-2">
				{contadorMaxLength ? <span className={contadorClassName}>{contadorMaxLength}</span> : null}
				{rightIconContent}
			</div>
		</InputAdornment>
	);
}
